import type { ReactNode } from "react";
import { AppSidebar } from "./AppSidebar";
import { GlobalHeader } from "./GlobalHeader";
import { MobileNav } from "./MobileNav";

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * Main app layout with:
 * - Global header at top (desktop) with breadcrumbs and context actions
 * - Floating icon sidebar (desktop, vertically centered) with notifications/profile
 * - Bottom nav (mobile)
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Desktop global header */}
      <div className="hidden lg:block sticky top-0 z-40">
        <GlobalHeader />
      </div>

      {/* Desktop floating sidebar */}
      <AppSidebar />

      {/* Main content area - no sidebar padding since sidebar floats */}
      <main className="pb-16 lg:pb-0 min-h-[calc(100vh-72px)]">
        {children}
      </main>

      {/* Mobile bottom navigation */}
      <MobileNav />
    </div>
  );
}
